export enum UserPermission {
  PL = 'PL',
  GL = 'GL',
  GA = 'GA',
  OP = 'OP',
  SP = 'SP',
  SA = 'SA',
  SG = 'SG',
  CF = 'CF',
  unknown = 'unknown',
}

export enum UserPermissionGroup {
  HUB = 'HUB',
  CD = 'CD',
}

export const getUserPermissionGroup = {
  [UserPermission.PL]: UserPermissionGroup.HUB,
  [UserPermission.GL]: UserPermissionGroup.HUB,
  [UserPermission.GA]: UserPermissionGroup.HUB,
  [UserPermission.OP]: UserPermissionGroup.CD,
  [UserPermission.SP]: UserPermissionGroup.CD,
  [UserPermission.SA]: UserPermissionGroup.HUB,
  [UserPermission.SG]: UserPermissionGroup.CD,
  [UserPermission.CF]: UserPermissionGroup.CD,
  [UserPermission.unknown]: undefined,
}
export const cdPermissions = [
  UserPermission.OP,
  UserPermission.SP,
  UserPermission.CF,
  UserPermission.SG,
]

export const hubPermissions = [
  UserPermission.PL,
  UserPermission.GL,
  UserPermission.GA,
]

export enum Modules {
  DeliveryPicking = 'DeliveryPicking',
  DeliveryDeliveries = 'DeliveryDeliveries',
  PickingTO = 'PickingTO',
  CheckingTO = 'CheckingTO',
  ReceiveTasks = 'ReceiveTasks',
}

export const PERMISSIONS: Record<Modules, UserPermission[]> = {
  [Modules.PickingTO]: [
    UserPermission.OP,
    UserPermission.SP,
    UserPermission.SG,
  ],
  [Modules.CheckingTO]: [UserPermission.CF, UserPermission.SG],
  [Modules.DeliveryPicking]: [
    UserPermission.GA,
    UserPermission.GL,
    UserPermission.PL,
    UserPermission.SA,
  ],
  [Modules.DeliveryDeliveries]: [
    UserPermission.GA,
    UserPermission.GL,
    UserPermission.PL,
    UserPermission.SA,
  ],
  [Modules.ReceiveTasks]: [
    UserPermission.GA,
    UserPermission.GL,
    UserPermission.PL,
    UserPermission.SA,
  ],
}

export const SUPERVISOR_PERMISSIONS: UserPermission[] = [
  UserPermission.SP,
  UserPermission.SG,
  UserPermission.SA,
  UserPermission.GA,
  UserPermission.GL,
]
